<template>
  <Modal v-bind="$attrs" :title="$t('reserve/sct')" v-on="$listeners">
    <template #contents>
      <div class="sct">{{ $i18n.locale === 'ja' ? sct.ja : sct.en }}</div>
    </template>
  </Modal>
</template>

<script>
import { mapState } from 'vuex'
import Modal from '@/components/molecules/Modal'

/**
 * 特商法モーダル
 */
export default {
  name: 'SctModal',
  components: {
    Modal,
  },
  computed: {
    ...mapState({
      sct: state => state.reception.sct,
    }),
  },
}
</script>

<style lang="postcss" scoped>
.sct {
  border: 1px solid var(--border-color);
  height: 100%;
  margin: 0 16px 16px;
  -webkit-overflow-scrolling: touch;
  overflow-y: auto;
  padding: 16px 8px;
  white-space: pre-line;
  word-break: normal;

  @media screen and (min-width: 672px) {
    margin: 0 24px 24px;
    padding: 16px;
  }
}
</style>
